var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"registration"}},[_c('div',{staticClass:"registration-page-container"},[_c('block-header-standard',{attrs:{"title":_vm.t('registration')}}),_c('div',{staticClass:"registration-form-container"},[_c('registration-form')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }